import { Button, Typography } from '@mui/material';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useResponsive } from 'src/hooks/useResponsive';
import useStyles from './styles';

export const ErrorPage: ComponentType<{ errorCode: number }> = ({ errorCode }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const r = useResponsive();

  return (
    <div className={classes.root}>
      <Typography variant="h1" component="h2" className={classes.code}>
        {errorCode}
      </Typography>
      <Typography variant={r({ xs: 'h4', md: 'h2' })} component="h2" className={classes.title}>
        {t(`errorPage.${errorCode}`)}
      </Typography>
      <Typography variant="body2" className={classes.text}>
        {t(`errorPage.${errorCode}.text`)}
      </Typography>
      <div className={classes.actions}>
        <Button
          color="secondary"
          variant="contained"
          component={Link}
          to="/"
          className={classes.btn}
        >
          {t(`errorPage.action.home`)}
        </Button>
        {errorCode !== 500 && (
          <Button className={classes.link}>{t(`errorPage.action.back`)}</Button>
        )}
      </div>
    </div>
  );
};
